<div
    class="d-flex w-100 overall-scorecard-widget"
    [class.align-items-start]="_collapsed"
>
    <cmps-container
        class="cmps-scorecard-widget--cmps-container"
        [collapsable]="false"
        variant="colored"
    >
        <cmps-container-header
            class="text-center"
            [headerColour]="headerColour"
            [textColour]="headerTextColour"
        >
            {{ _widget.name }}
        </cmps-container-header>
        <cmps-container-content [backgroundColour]="backgroundColour">
            <cmps-wait-status
                [srStatus]="'Loading ' + _widget.name"
                *ngIf="_isLoadingData | async"
            ></cmps-wait-status>
            <div
                *ngIf="
                    !(_isLoadingData | async) && _overallScores?.length === 0
                "
            >
                {{ _i18n._711_NO_DATA_AVAILABLE | translate }}
            </div>
            <div
                class="w-100"
                *ngIf="
                    !(_isLoadingData | async) && _overallScores?.length !== 0
                "
            >
                <div class="d-flex">
                    <div class="w-50 cmps-overall-pulse-widget--scores">
                        <div
                            class="sc-widget-content-row"
                            *ngFor="let overalScore of _overallScores"
                        >
                            <div
                                class="d-flex align-items-center justify-content-center sc-widget-grid-title"
                                [style.color]="textColour"
                            >
                                {{ overalScore.scoreText }}
                            </div>
                            <div
                                class="d-flex align-items-center justify-content-center sc-widget-grid-value"
                                [style.color]="textColour"
                            >
                                {{
                                    (overalScore.scoreValue
                                        | number: '1.0-2') || '-'
                                }}
                            </div>
                        </div>
                    </div>
                    <div class="w-50 cmps-overall-pulse-widget--trend d-flex">
                        <div
                            class="d-flex flex-column align-items-center justify-content-center sc-widget-grid-title"
                        >
                            <div class="cmps-overall-pulse-widget--info-lbl">
                                {{ _i18n._9404_SCORE_TREND | translate }}
                            </div>
                            <div
                                class="cmps-overall-pulse-widget--info-duration"
                            >
                                {{
                                    _data?.header?.startDate
                                        | cmpsDate: 'LLL-dd-y'
                                }}
                                {{ _i18n._9253_TO | translate }}
                                {{
                                    _data?.header?.endDate
                                        | cmpsDate: 'LLL-dd-y'
                                }}
                            </div>
                        </div>
                        <div
                            class="d-flex align-items-center justify-content-center sc-widget-grid-value"
                            [ngSwitch]="_data?.header?.trendId"
                        >
                            <div
                                class="p-1 font-weight-bold"
                                [cmpsTooltipTrigger]="
                                    _i18n._9403_PREVIOUS_SCORECARD_NOT_AVAILABLE_FOR_COMPARE
                                        | translate
                                "
                                *ngSwitchDefault
                            >
                                <span
                                    class="cmps-overall-pulse-widget--trend-neutral"
                                    >{{ _i18n._9402_NA | translate }}</span
                                >
                            </div>
                            <cmps-icon
                                class="cmps-overall-pulse-widget--trend-up"
                                svgIcon="trending-up"
                                [cmpsTooltipTrigger]="tooltipTpl"
                                *ngSwitchCase="_TrendType.UP"
                            ></cmps-icon>
                            <cmps-icon
                                class="cmps-overall-pulse-widget--trend-down"
                                svgIcon="trending-down"
                                [cmpsTooltipTrigger]="tooltipTpl"
                                *ngSwitchCase="_TrendType.DOWN"
                            ></cmps-icon>
                            <cmps-icon
                                class="cmps-overall-pulse-widget--trend-neutral"
                                svgIcon="trending-neutral"
                                [cmpsTooltipTrigger]="tooltipTpl"
                                *ngSwitchCase="_TrendType.NEUTRAL"
                            ></cmps-icon>
                        </div>
                    </div>
                </div>
                <div
                    class="cmps-overall-pulse-widget--category"
                    *ngIf="_widget?.options?.showCategory"
                >
                    <div class="cmps-overall-pulse-widget--label">
                        {{ _i18n._9880_MI2_SCORECARD_CATEGORY | translate }}
                    </div>
                    <div class="cmps-overall-pulse-widget--class">
                        <div
                            [style.border-color]="
                                _data?.header?.performanceClass?.colour
                            "
                            class="cmps-overall-pulse-widget--category-value"
                        >
                            <span
                                class="cmps-overall-pulse-widget--category-value-label"
                                >{{
                                    _data?.header?.performanceClass
                                        ?.scorecardPerformanceClassName ??
                                        (_i18n._9402_NA | translate)
                                }}</span
                            >
                            <span
                                [style.background-color]="
                                    _data?.header?.performanceClass?.colour
                                "
                                class="cmps-overall-pulse-widget--category-value-bar"
                            ></span>
                        </div>
                    </div>
                </div>
            </div>
        </cmps-container-content>
    </cmps-container>
</div>

<ng-template #tooltipTpl>
    <div>
        {{ _i18n._9405_CURRENT_ | translate }}
        {{ (_data?.header?.adjustedPoints | cmpsNumber: '1.0-2') || '-' }}
    </div>
    <div>
        {{ _i18n._9406_PREVIOUS_ | translate }}
        {{ (_data?.header?.prevAdjustedPoints | cmpsNumber: '1.0-2') || '-' }}
    </div>
</ng-template>
